import { render, staticRenderFns } from "./LottoInformationTable.vue?vue&type=template&id=6792a94a&"
import script from "./LottoInformationTable.vue?vue&type=script&lang=js&"
export * from "./LottoInformationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports